import { render, staticRenderFns } from "./UserSetupProfile.vue?vue&type=template&id=5f07909d&scoped=true&"
import script from "./UserSetupProfile.vue?vue&type=script&lang=js&"
export * from "./UserSetupProfile.vue?vue&type=script&lang=js&"
import style0 from "./UserSetupProfile.vue?vue&type=style&index=0&id=5f07909d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f07909d",
  null
  
)

export default component.exports